import React, { useEffect, useState } from 'react'

import CountryPage from 'Containers/Country/Page'
import { authorization } from '../../../../Module/Auth/Auth'

// Older Promofy Planka boards were created with id == oppizi country.id
// (Australia=1, Mexico=17, etc.) so the iframe URL `/boards/${country.id}`
// just works. Newer boards get Planka's snowflake-style ids and won't
// match. Map them here so the iframe still opens the right board.
const COUNTRY_TO_PLANKA_BOARD_ID = {
  // Israel (country.id 29) → Middle East board
  29: '1717597422470825842',
}

const ProjectManagement = props => {
  const key = authorization.getAPIKey()
  const user = authorization.getUser()
  const [isOpen, setIsOpen] = useState(false)
  const plankaBoardId =
    COUNTRY_TO_PLANKA_BOARD_ID[props.country.id] || props.country.id

  useEffect(() => {
    const handleMessage = event => {
      // eslint-disable-next-line no-console
      console.log('ProjectManagement > handleMessage > event', event)
      try {
        if (event.name === 'toggleView') {
          setIsOpen(event.isOpen)
        }
        if (event.data.name === 'toggleView') {
          setIsOpen(event.data.isOpen)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('ProjectManagement > handleMessage', error)
      }
    }
    window.addEventListener('message', handleMessage)
  }, [])

  return (
    <CountryPage
      country={props.country}
      breadcrumbs={[
        {
          label: 'Project Management',
        },
      ]}
    >
      <iframe
        allow="clipboard-read; clipboard-write"
        id="planka-iframe"
        src={`https://planka.promofy.marketing/boards/${plankaBoardId}?token=${key}&userId=${
          user.id
        }&userEmail=${encodeURIComponent(
          user.email,
        )}&countryName=${encodeURIComponent(user.countryName)}`}
        height="100%"
        width="100%"
        title="Promofy Planka"
        style={
          isOpen
            ? {
                border: 'none',
                height: 'calc(100vh - 70px)',
                margin: '0px',
                position: 'absolute',
                top: '0',
              }
            : { border: 'none', height: 'calc(100vh - 292px)', margin: 0 }
        }
        className={`planka-iframe__${isOpen ? 'open' : 'closed'}`}
      />
    </CountryPage>
  )
}

export default ProjectManagement
